export default __webpack_public_path__ + "static/media/home-img.8432b47a.png";